import React from 'react'
import { View, Text } from 'react-native'
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import { Button, TextInputContainer, CachedImage, Storage } from '../../../components';
import UserAvatar from '../../../components/Users/UserAvatar';
import Images from '../../../constants/Images';
import styles from './styles';
import PDFReader from 'rn-pdf-reader-js';

export const ImageChange = ({ item, acceptChange, rejectChange, makeChange }) => {
  const [newValue, setNewValue] = React.useState(item.new_value);
  const [editable, setEditable] = React.useState(false);
  let textInput = React.useRef(null);

  const [headers, setHeaders] = React.useState({});
  React.useEffect(() => {
    (async () => {
      const rtJWT = await Storage.getItem('rtJWT');
      setHeaders({ 'Authorization': `Bearer ${rtJWT}` });
    })()
  }, []);

  const onChangeNewValue = (val) => {
    setNewValue(val);
  }
  const accept = () => {
    console.log('accept()');
    acceptChange(item);
  }
  const reject = () => {
    console.log('reject()');
    rejectChange(item);
  }
  const makeAChange = () => {
    console.log('makeAChange');
    setEditable(true);
    setTimeout(() => {
      textInput.current.focus();
    }, 100);
  }
  const saveChange = () => {
    if (item.new_value !== newValue) {
      makeChange(item, newValue);
    }
    console.log('saveChange')
    setEditable(false);
  }
  const cancelChange = () => {
    setNewValue(item.new_value);
    setEditable(false);
  }

  return (
    <View>
      {/* <Text style={[CS.smallTitle, CS.lightText]}>Caption</Text> */}
      <View style={[CS.rowContainer, { marginBottom: 20 }]}>
        <UserAvatar userId={item.avatar.id} avatar={item.avatar.version} size='medium' />
        <Text style={[CS.smallText, CS.lightBlueText, { marginLeft: 10 }, CS.flex]}>{item.memo}</Text>
      </View>
      {item.captionType === 'image' ?
        <CachedImage source={{ uri: item.path }} style={[styles.imgCaption, { aspectRatio: Images.project.width / Images.project.height }]} />
        :
        null
      }
      {item.captionType === 'file' ? 
        <View style={[styles.pdfContainer, { aspectRatio: Images.project.width / Images.project.height }]}>
          <PDFReader source={{ uri: item.path, headers: headers }} />
          {/* <Text>PDFReader removed...</Text> */}
        </View>
        :
        null
      }
      <Text style={[CS.smallText, CS.lightBlueText, CS.boldText, { marginVertical: 10 }]}>From</Text>
      <View style={styles.oldCaption}>
        <Text style={[CS.smallText, CS.blueText]}>{item.old_value}</Text>
      </View>
      <Text style={[CS.smallText, CS.lightBlueText, CS.boldText, { marginBottom: 10 }]}>To</Text>
      <TextInputContainer
        placeholder='Photo caption.'
        onChangeText={(t) => onChangeNewValue(t)}
        inputRef={textInput}
        // isInvalid={isInvalid.projectDescription}
        returnKeyType='done'
        value={newValue}
        // inputStyle={styles.description}
        autoCorrect={false}
        spellCheck={true}
        editable={editable}
      />
      {!editable &&
        <View style={CS.rowContainer}>
          <View style={styles.buttonLeft}>
            <Button text='Accept' onPress={() => accept} />
          </View>
          <View style={styles.buttonMiddle}>
            <Button text='Reject' onPress={() => reject} color='red' />
          </View>
          <View style={styles.buttonRight}>
            <Button text='Change' onPress={() => makeAChange} color='blue' />
          </View>
        </View>
      }
      {editable &&
        <View style={[CS.rowContainer, { marginTop: 10, marginBottom: 10 }]}>
          <View style={CS.buttonLeft}>
            <Button text='Save' onPress={() => saveChange} color='blue' />
          </View>
          <View style={CS.buttonRight}>
            <Button text='Cancel' onPress={() => cancelChange} color='red' />
          </View>
        </View>
      }
    </View>
  );
}

export default ImageChange;